<div class="row">
  <div class="col-12">
    
    <div class="serverErrorMessage" *ngIf="serverErrorMessageShown">
      <div class="alert alert-danger mb-4 py-4" role="alert" >
        <p>We encountered an issue completing your request.</p>
        <span>Please contact Customer Service at {{ customerServicePhone }}.</span>
      </div>
    </div>

    <form id="resetPasswordByPhoneForm" [formGroup]="resetPasswordByPhoneForm" (ngSubmit)="resetPasswordByPhone()">
    
      <div class="form-group form-label-group">
        <input id="usernameInput" formControlName="usernameInput" class="form-control" placeholder="Enter Username"
          [ngClass]="{ 'is-invalid': sendVerificationSmsButtonClicked && resetPasswordByPhoneForm.controls.usernameInput.errors }">
        <label for="usernameInput">Username</label>
        <div *ngIf="sendVerificationSmsButtonClicked && resetPasswordByPhoneForm.controls.usernameInput.errors" class="invalid-feedback">
          <div *ngIf="resetPasswordByPhoneForm.controls.usernameInput.errors.required">Username is required.</div>
        </div>
      </div>
    
      <div class="form-group form-label-group">
        <input id="phoneNumberInput" formControlName="phoneNumberInput" class="form-control"
          placeholder="Enter Verified Phone Number"
          [ngClass]="{ 'is-invalid': sendVerificationSmsButtonClicked && resetPasswordByPhoneForm.controls.phoneNumberInput.errors }"
          mask="(000) 000-0000">
        <label for="phoneNumberInput">Verified Phone Number</label>
        <div *ngIf="sendVerificationSmsButtonClicked && resetPasswordByPhoneForm.controls.phoneNumberInput.errors" class="invalid-feedback">
          Phone Number is invalid.
          <div *ngIf="resetPasswordByPhoneForm.controls.phoneNumberInput.errors.required">Phone Number is required.</div>
          
        </div>
      </div>
    
      <div class="row" *ngIf="!verificationSmsRequestSent" [@showSendVerificationSmsButton]>
        <div class="col-12 d-flex">
          <button type="submit" form="resetPasswordByPhoneForm" class="btn rounded-pill bg-secondary ml-auto text-white">
            <span class="font-weight-bold">Send Verification Code</span>
          </button>
        </div>
      </div>
    </form>

    <div *ngIf="verificationSmsRequestSent" [@showConfirmationCodeWindow]>
      <app-verify-confirmation-code-by-phone [username]="getUsernameValue()" [phoneNumber]="getPhoneNumberValue()">
      </app-verify-confirmation-code-by-phone>
    </div>

  </div>
</div>
